module.exports = __webpack_public_path__ + "c46a1a39f3ea77a5e1ba6d389714446e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ClanFFBlack.woff
// module id = 619
// module chunks = 0